<app-template>

    <!-- FAD MASIVO DESKTOP-->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="main-payment">
            <p>
                CONFIRMAÇÃO DE COMPRA
            </p>s
        </div>

        <div class="info">
            <p class="max-width"> Seu pedido <span>foi confirmado</span></p>
        </div>

        <div class="payment-content">
            <div class="container max-width">
                <div class="header">
                </div>

                <mat-divider></mat-divider>

                <div class="description-product">
                    <div class="description">
                        <p class="semi" *ngFor="let product of products">
                            - {{product.product}} - {{product.subscription}}
                        </p>
                        <p>A compra de seus produtos foi confirmada e será ativada em breve. Verifique seu pedido de compra em seu e-mail.</p>
                    </div>
                    <div class="image">
                    </div>
                </div>

                <div class="line-steps">
                    <div class="step active"></div>
                    <div class="step active"></div>
                    <div class="step active"></div>
                    <div class="step active"></div>
                </div>

                <div class="info-purchase data-purchase-item">
                    <p class="title">INFORMAÇÃO DA CONTA</p>
                    <div class="items">
                        <div class="item">
                            <p class="name">Nome</p>
                            <p class="value">{{userData?.name}} {{userData?.lastName}}</p>
                        </div>
                        <div class="item">
                            <p class="name">E-mail</p>
                            <p class="value">{{userData?.email}}</p>
                        </div>
                        <div class="item">
                            <p class="name">Tipo de produto</p>
                            <p class="value">{{userData.isCompany ? 'EMPRESARIAL' : 'PESSOAL'}}</p>
                        </div>
                    </div>
                </div>

                <div class="info-purchase data-purchase-item" *ngIf="billingData !== null && billingData !== ''">
                    <p class="title">DADOS DE FATURAÇÃO</p>
                    <div class="items">
                        <div class="item">
                            <p class="name">País</p>
                            <p class="value">{{billingData?.country}}</p>
                        </div>
                        <div class="item">
                            <p class="name">Estado</p>
                            <p class="value">{{billingData?.state}}</p>
                        </div>
                        <div class="item">
                            <p class="name">Cidade</p>
                            <p class="value">{{billingData?.city}}</p>
                        </div>
                        <div class="item">
                            <p class="name">CEP</p>
                            <p class="value">{{billingData?.code}}</p>
                        </div>
                        <div class="item middle">
                            <p class="name">Endereço </p>
                            <p class="value">{{billingData?.address}}</p>
                        </div>
                        <div class="item middle">
                            <p class="name">CPF/CNPJ</p>
                            <p class="value">{{billingData?.rfc}}</p>
                        </div>
                    </div>
                </div>

                <div class="products-summary">
                    <p class="title">
                        Informação do produto
                    </p>
                    <div class="table">
                        <div class="header">
                            <p class="w-40">Produto</p>
                            <p>Preços</p>
                            <p>Quantidade</p>
                            <p>Total</p>
                        </div>
                        <hr style="width: 100%; border: 2px solid grey; border-radius: 5px; margin-top: -20px">
                        <div class="product" *ngFor="let product of products">
                            <div class="principal">
                                <div class="column w-40">
                                    <p class="semi">
                                        {{product.product}} - {{product.subscription}}
                                    </p>
                                    <p>
                                        {{product.usuarios}} {{product.usuariosLabel}} - {{product.transactions}}
                                        - {{product.transactionType}}
                                    </p>
                                </div>
                                <div class="column">
                                    <p class="semi">
                                        <span>{{product.pricingInfo}}$ {{ getPriceCentavos(product.pricing) | formatoMil }} </span>
                                    </p>
                                </div>
                                <div class="column">
                                    <p class="semi">
                                        {{product.quantity}}
                                    </p>
                                </div>
                                <div class="column">
                                    <p class="semi">
                                        <span>{{product.pricingInfo}}$ {{getPriceCentavos(product.quantity * product.pricing)  | formatoMil }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <mat-divider></mat-divider>
                    <p style="font-size:20px ;text-align: center; padding: 20px; font-family: 'Montserrat-Bold', sans-serif" *ngIf="getTotalDescuento() !== null">
                        "Um desconto foi aplicado a esta compra para o código inserido na etapa anterior."
                    </p>
                    <p class="total">
                        <span>Total: R$ {{ getTotalDescuento() === null ? getTotalIVA(getTotal(0)) : getTotalIVA(getTotalDescuento())}}</span>
                    </p>
                    <div class="button" (click)="goToBackOffice()">
                        INSIRA SUA CONTA
                    </div>
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/personalfotos.png">
            </div>
            <div class="content-res">
                CONFIRMAÇÃO DE COMPRA
                <p class="text">
                    Seu pedido <strong>foi confirmado</strong>
                </p>
                <p class="text" *ngFor="let product of products">
                    - {{product.product}} - {{product.subscription}}
                </p>
                <p class="text">A compra de seus produtos foi confirmada e será ativada em breve. Verifique seu pedido de compra em seu e-mail.</p>
            </div>
            <mat-divider></mat-divider>

            <div class="content-res" *ngIf="userData !== null && userData !== ''">
                INFORMAÇÃO DA CONTA
                <div class="text">
                    <p class="value">Nome: <br><span>{{userData?.name}} {{userData?.lastName}}</span></p>
                </div>
                <div class="text">
                    <p class="value">E-mail: <br><span>{{userData?.email}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Tipo de produto:
                        <span>{{userData.isCompany ? 'EMPRESARIAL' : 'PESSOAL'}}</span></p>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="content-res" *ngIf="billingData !== null && billingData !== ''">
                DADOS DE FATURAÇÃO
                <div class="text">
                    <p class="value">País: <span>{{billingData?.country}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Estado: <br><span>{{billingData?.state}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Cidade: <br><span>{{billingData?.city}}</span></p>
                </div>
                <div class="text">
                    <p class="value">CEP: <span>{{billingData?.code}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Endereço: <br><span>{{billingData?.address}}</span></p>
                </div>
                <div class="text">
                    <p class="value">CPF/CNPJ: <span>{{billingData?.rfc}}</span></p>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="content-res">
                INFORMAÇÃO <span>DO PRODUTO</span>
                <br>
                <div class="box-product" style="font-size: 20px; margin-top: 20px">
                    <p class="title-header" style="padding-left: 30px">Plano:</p>
                    <mat-divider class="margin-plus" style="background: white"></mat-divider>
                    <ng-container *ngFor="let x of products.length | fill ; let i = index">
                        <div class="products">
                            <div class="check-product">
                                <p><span>{{products[i].product}}</span> - {{products[i].subscription}}:</p>
                                <p class="price" >{{products[i].pricingInfo}}$ {{getPriceCentavos(products[i].pricing) | formatoMil }}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <mat-divider></mat-divider>
            <p style="font-size:15px ;text-align: center; padding: 0 20px; font-family: 'Montserrat-Light', sans-serif" *ngIf="getTotalDescuento() !== null">
                "Um desconto foi aplicado a esta compra para o código inserido na etapa anterior."
            </p>
            <div class="content-res">
                <div class="final-price">
                    <p>Total: </p>
                    <p><span>R$ {{ getTotalDescuento() === null ? getTotalIVA(getTotal(0)) : getTotalIVA(getTotalDescuento())}}</span></p>
                </div>
            </div>
            <p style="font-size:15px ;text-align: center; padding: 0 20px; font-family: 'Montserrat-Light', sans-serif">
                "Para começar a usar suas transações, faça login em <span
                    style="cursor: pointer; font-family: 'Montserrat-SemiBold', sans-serif"><a
                    (click)="goToBackOffice()">Portal do Cliente</a></span> seu
                computador desktop ou apenas clicar no link encontrado no e-mail de
                Confirmação de compra."
            </p>
            <br>
        </div>
    </div>

</app-template>
